export default __webpack_public_path__ + "static/media/marble-popup-bnb-img.88746d8f.jpg";